import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { WHAT_TO_EXPECT, PDF_BG } from "../data/content";
import SectionBg from "./SectionBg";

export default function WhatToExpect() {
    return (
        <section
            id="expect"
            className="relative py-24 md:py-40 overflow-hidden"
            data-testid="expect-section"
        >
            <SectionBg src={PDF_BG.expect} opacity={0.6} />
            {/* Background accent */}
            <div className="pointer-events-none absolute top-1/4 -right-40 w-[500px] h-[500px] rounded-full bg-[#9D4CDD]/15 blur-[150px]" />

            <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-12 md:mb-16">
                    <div className="col-span-12 md:col-span-4">
                        <div className="text-xs uppercase tracking-[0.3em] text-[#FF6B35] font-mono mb-6">
                            What to Expect
                        </div>
                    </div>
                    <h2 className="col-span-12 md:col-span-8 min-w-0 max-w-full font-display font-bold text-[1.62rem] leading-[1.14] tracking-normal break-words [overflow-wrap:anywhere] sm:text-5xl sm:leading-[1.05] sm:tracking-tight lg:text-6xl">
                        Two days engineered for{" "}
                        <span className="text-stroke-orange">collision</span>.
                    </h2>
                </div>

                {/* Bento grid */}
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    {WHAT_TO_EXPECT.map((item, i) => (
                        <motion.div
                            key={item.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ delay: i * 0.06, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                            whileHover={{ y: -6 }}
                            className={`${item.span} group relative overflow-hidden rounded-3xl border border-white/10 bg-[#141414] p-5 sm:p-8 md:p-10 cursor-default hover:border-[#FF6B35]/60 transition-all duration-500`}
                            data-testid={`expect-card-${i}`}
                        >
                            {/* Hover glow */}
                            <div className="pointer-events-none absolute -inset-px rounded-3xl bg-gradient-to-br from-[#FF6B35]/0 via-transparent to-[#9D4CDD]/0 group-hover:from-[#FF6B35]/20 group-hover:to-[#9D4CDD]/20 transition-all duration-700 opacity-0 group-hover:opacity-100" />

                            <div className="relative flex flex-col h-full justify-between min-h-[180px] sm:min-h-[200px]">
                                <div>
                                    <div className="text-xs uppercase tracking-[0.25em] text-[#FF6B35] font-mono mb-4">
                                        0{i + 1}
                                    </div>
                                    <h3 className="max-w-[calc(100%-1.75rem)] font-display text-[1.45rem] leading-tight font-bold tracking-normal break-words [overflow-wrap:anywhere] text-white group-hover:text-[#FF6B35] transition-colors sm:text-2xl md:text-3xl md:tracking-tight">
                                        {item.title}
                                    </h3>
                                </div>
                                <p className="mt-6 text-sm leading-relaxed text-zinc-400 sm:text-base">{item.copy}</p>
                                <ArrowUpRight
                                    size={20}
                                    className="absolute top-0 right-0 text-zinc-600 group-hover:text-[#FF6B35] group-hover:rotate-45 transition-all duration-500"
                                />
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
